module.exports = __webpack_public_path__ + "static/media/pink-robin-logo.830b9111.png";